<template>
  <div style="margin-top:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Route Assignments</span><br/>
      <span style="font-style: italic; font-size: 18px">View vehicle and driver assignments for routes by date.  Results in <span style="color:darkred; font-weight: bold">red</span> are mismatches between routes and bookings</span>
    </div>

    <div style="font-size: 20px; font-weight: bold; position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;<b-button size="md" @click="load_data()">Search</b-button>

      &nbsp;&nbsp;|&nbsp;&nbsp;Filter:&nbsp;<b-form-input style="width: 200px" v-model="route_filter" placeholder=""/>

    </div>
    <br/>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="vehicle" slot-scope="row">
          <span v-if="row.item.vehicle && row.item.vehicle.indexOf('(') != -1" style="color: darkred; font-weight: bold">
            {{row.item.vehicle}}
          </span>
          <span v-else>
            {{row.item.vehicle}}
          </span>
        </template>

        <template slot="driver" slot-scope="row">
          <span v-if="row.item.driver && row.item.driver.indexOf('(') != -1" style="color: darkred; font-weight: bold">
            {{row.item.driver}}
          </span>
          <span v-else>
            {{row.item.driver}}
          </span>
        </template>

        <template slot="startTime" slot-scope="row">
          {{row.item.startTime | formatDateTimeSmall}}
        </template>

        <template slot="finishTime" slot-scope="row">
          {{row.item.finishTime | formatDateTimeSmall}}
        </template>

      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>

  </div>

</template>

<script>

import {get_route_assignments, get_route_patterns} from '../networking/apis'
import {mapState} from "vuex";
import moment from "moment";
import {justDate} from "../helpers/dates";

    export default {
      name: 'route_assignments',
      components: {
      },

      data() {
        return {
          toggle: {},
          file: null,
          details_fromDate: justDate(moment()),
          items: [],
          items_full: [],
          route_options: [],
          route_filter: '',
          selected_address: null,
          summary: [],
          center: null,
          zoom: null,
          markers: [],
          markers_full: [],
          shapes: [],
          shapes_full: [],
          loading: false,
          totalRows: 1,
          currentPage: 1,
          perPage: 400,
          pages: [],
          options: {
            format: 'MM-DD-YYYY',
            useCurrent: true,
            minDate: moment().subtract(90, 'days'),
            maxDate: moment().add(90, 'days'),
            keepOpen: false,
            showClear: true,
            showClose: true,
          },
          fields_all: [],
          fields: [
            { key: 'routeName', sortable: true},
            { key: 'vehicle', sortable: true},
            { key: 'driver', sortable: true},
            { key: 'startTime', label: 'Scheduled Start', sortable: true},
            { key: 'finishTime', label: 'Scheduled Finish', sortable: true},
          ]

        }
      },
      async created() {
        await this.load_data()
      },
      methods: {
        async load_data() {
          this.loading = true
          try {
            const {value: { data = [] } } = await get_route_assignments(this.user.tenant, '', moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
            this.items = data.results
            this.items_full = data.results
            this.summary = data.summary
            moment.tz.setDefault(this.summary.timezone)

          } catch(e) {
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
          }

          this.loading = false
        },
        async shift_detail_graph_date(shift) {
          this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
        },
        filter_results() {
          this.items = this.items_full
          if (this.route_filter) {
            this.items = this.items.filter(item => this.contains(item.vehicle,this.route_filter) || this.contains(item.routeName,this.route_filter) || this.contains(item.driver,this.route_filter))
          }
        },
        contains(val1, val2) {
          if (val1 != null) {
            return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
          }
          return false;
        }

      },

      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
      },
      watch: {
        user: {
          deep: true,
          handler() {
            this.load_data()
          }
        },
        details_fromDate() {
          this.load_data()
        },
        route_filter() {
          this.filter_results()
        },
      }
    }
</script>

<style>

  div.row:nth-child(even) {
    background-color: #f2f2f2;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  .header {
    font-weight: bold;
  }

  div.col {
    border: 1px solid grey;
  }

  .table td {
    padding: .1rem !important;
  }

  .list-text {
    text-align: left;
    margin-top: 7px;
    margin-left: 7px;
  }

  .list-option {
    text-align: left;
    margin: 2px;
  }
</style>

